const GameState = {
    playerXWins: 0,
    playerOWins: 1,
    draw: 2,
    inProcess: 3,
};

export default GameState;